// src/redux/sidebarSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	selectedModule: null,
	isOpen: false,
};

const sidebarSlice = createSlice({
	name: "sidebar",
	initialState,
	reducers: {
		setSelectedModule: (state, action) => {
			state.selectedModule = action.payload;
		},
		toggleSidebar: (state) => {
			state.isOpen = !state.isOpen;
		},
		openSidebar: (state) => {
			state.isOpen = true;
		},
		closeSidebar: (state) => {
			state.isOpen = false;
		},
	},
});

export const { setSelectedModule, clearSelectedModule, toggleSidebar, openSidebar, closeSidebar } =
	sidebarSlice.actions;
export default sidebarSlice.reducer;
